/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Agent_QuestionInputs */

const en_landing_faq_agent_question = /** @type {(inputs: Landing_Faq_Agent_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Inginuiti an AI agent?`)
};

/**
* | output |
* | --- |
* | "Is Inginuiti an AI agent?" |
*
* @param {Landing_Faq_Agent_QuestionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_faq_agent_question = /** @type {((inputs?: Landing_Faq_Agent_QuestionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Agent_QuestionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_faq_agent_question(inputs)
});